<script lang="ts">
  import type {Color} from "$lib/componentTypes";
  import type { HTMLAttributes } from "svelte/elements";

  interface Props extends HTMLAttributes<HTMLDivElement> {
    color?: Color;
  }

  let {color = 'primary', children, ...props}: Props = $props();
</script>

<div class={["alert", `alert-${color}`]} {...props}>{@render children?.()}</div>

